import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import Timer from '../timer';
import { getCustomIconText } from '../../utils/TaskUtils';
import { i18n } from '../../utils/GadgetUtils';
import styles from "./taskList.module.css";

const TaskItem = (props) => {
	const taskItemRef = useRef(null);

	useEffect(() => {
		taskItemRef.current.taskItemProp = props;
		if (props.active) {
			console.log(': taskItem useeffect making active....', props);
			taskItemRef.current.selected = true;
		} else {
			taskItemRef.current.selected = false;
		}
	}, [props.task, props.active]);

	const getTaskAriaLabel = () => {
		return `${props.task.mediaType} ${i18n.getMsg('gadget.imi.operation.taskitem.arialabel')} ${props.task.title}, ${props.task.queue} ${props.task.quantity ? ',' + props.task.quantity + i18n.getMsg('gadget.imi.operation.taskitem.arialabel') : ""}, ${props.task.lastmessage ? props.task.lastmessage : ""}`;
	}

	const handleKeyDown = event => {
		if (event.keyCode === 40) {
			event.preventDefault();
			if (event.currentTarget.closest('.tasklistclass').nextElementSibling) {
				event.currentTarget.closest('.tasklistclass').nextElementSibling.focus();
			} else {
				document.getElementsByClassName('tasklistclass')[0] && document.getElementsByClassName('tasklistclass')[0].focus()
			}
		} else if (event.keyCode === 38) {
			event.preventDefault();
			if (event.currentTarget.closest('.tasklistclass').previousElementSibling) {
				event.currentTarget.closest('.tasklistclass').previousElementSibling.focus();
			} else {
				let tasks = document.getElementsByClassName('tasklistclass');
				tasks.length > 0 ? document.getElementsByClassName('tasklistclass')[tasks.length - 1].focus(): '';
			}
		} else if (event.keyCode === 13) {
			 event.preventDefault();
				const _target = event.currentTarget.querySelector('md-task-item')
				const newEvent = new CustomEvent('taskitem-click', { 'target': _target});
				Object.defineProperty(newEvent, 'target', {value: _target, enumerable: true});
				window.dispatchEvent(newEvent);
		}
	};

	return (
		<div className={`${styles["tasklistitem"]} tasklistclass`} tabIndex={props.active ? "0" : "-1"} onKeyDown={handleKeyDown}>
			<md-task-item
				id={props.task.taskId}
				mediaType={props.task.mediaType}
				status={props.task.status}
				title={props.task.title}
				queue={props.task.queue}
				lastmessage={props.task.lastmessage}
				quantity={props.task.quantity}
				ref={taskItemRef} 
				aria-label={getTaskAriaLabel()} tabIndex="-1"
			>
				{/* Below md-badge will show a icon with custom text if incase mediaType prop passed to md-task-item is invalid  */}
				<md-badge bgColor="#CCCCCC" textColor="black" circle slot="task-type">{getCustomIconText(props.task.mediaType)}</md-badge>
				<div>
				<Timer id="task-item-timer"
					displayFormat="hh:mm:ss"
					dynamicFormat={true}
					show={true}
					reset={true}
     				startTime={(new Date().getTime() / 1000) - props.task.timeStamp}
					isInterrupted = {props.task.isInterrupted}
					/>
				</div>
			</md-task-item>
		</div>
	);
};

TaskItem.propTypes = {
	task: PropTypes.object,
	active: PropTypes.any,
	setTaskItemRef: PropTypes.func
};

export default TaskItem;
